export default "__VITE_ASSET__cfaba29c__"